<template>
    <div class="pa-5" v-if="activeCampaign">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Name") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCampaign.name ? activeCampaign.name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Description") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCampaign.description ? activeCampaign.description : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Info provider") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCampaign.info_provider ? capitalizeFirstLetter(activeCampaign.info_provider) : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{
                activeCampaign.info_provider === "odoo" ? t("Export client") : t("Store")
            }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeCampaign.info_provider === "odoo"
                        ? activeCampaign.related_export_client_name || "-"
                        : activeCampaign.related_store_name || "-"
                }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{
                activeCampaign.info_provider === "odoo" ? t("Client") : t("Tag")
            }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeCampaign.info_provider === "odoo"
                        ? activeCampaign.related_client_name || "-"
                        : activeCampaign.related_tag_name || "-"
                }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("Start date") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCampaign.start_date ? activeCampaign.start_date : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ t("End date") }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCampaign.end_date ? activeCampaign.end_date : "-" }}
            </v-col>
        </v-row>

        <v-simple-table class="mt-4" v-if="activeCampaign.products && activeCampaign.products.length > 0">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>{{ t("Product code") }}</th>
                        <th>{{ t("Product name") }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="product in activeCampaign.products" :key="product.id">
                        <td>{{ product.code }}</td>
                        <td>{{ product.name }}</td>
                        <td></td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { helperMixin } from "@/mixins/helper-mixin";

export default {
    name: "general-tab",
    data() {
        return {};
    },
    computed: {
        ...mapState("CampaignStore", ["activeCampaign"])
    },
    mixins: [helperMixin]
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
